module.exports = __webpack_public_path__ + "static/assets/7d5033381647aae86d065d6d7825473f.png";